import { useSyncExternalStore } from 'react';

/**
 * A draft the assistant wrote for a Repeat clients client, waiting for the
 * compose page (Thomas, 2026-10-24: "have it draft a perfect email for the
 * client"). Module state, so it survives the navigation the panel does to get
 * there; nothing is stored or sent until the rep presses Send.
 */
export interface PendingDraft {
  readonly accountId: string;
  readonly contactId: string;
  readonly subject: string;
  readonly body: string;
  readonly templateId: string | null;
  /** Changes with every draft, so the compose form starts over for a new one. */
  readonly nonce: number;
}

let pending: PendingDraft | null = null;
let counter = 0;
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

/** The assistant's draft lands here; the compose page picks it up. */
export function offerDraft(draft: Omit<PendingDraft, 'nonce'>): void {
  counter += 1;
  pending = { ...draft, nonce: counter };
  emit();
}

/** Forgets the draft once it has been sent. */
export function clearDraft(): void {
  pending = null;
  emit();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** The waiting draft for this client, or null. */
export function usePendingDraft(accountId: string): PendingDraft | null {
  const draft = useSyncExternalStore(subscribe, () => pending);
  return draft !== null && draft.accountId === accountId ? draft : null;
}
